import React from 'react';
import PropTypes from 'prop-types';
import styles from './AnimatedVariantSelection.module.scss';
import VariantSelection from '../../../blocks/pdpV2/VariantSelection';
import AnimationWrapper from '../AnimationWrapper';

const AnimatedVariantSelection = ({
  isShowing,
  isShowingPriceDetails = true,
  isShowingDiscountedPrices = false,
  attributesExtraInfo = [],
  attributesUpperTitle = undefined,
  productName = undefined,
  variants,
  defaultSelectedSKU = undefined,
  onSelectVariant,
  attributeTitlePrefix = undefined,
  productKey = null,
}) => (
  <AnimationWrapper
    isShowing={isShowing}
    onShowClassName={styles.slideOut}
    onHideClassName={styles.slideIn}
  >
    <VariantSelection
      productKey={productKey}
      variants={variants}
      defaultSelectedSKU={defaultSelectedSKU}
      onSelectVariant={onSelectVariant}
      isShowingPriceDetails={isShowingPriceDetails}
      isShowingDiscountedPrices={isShowingDiscountedPrices}
      attributesExtraInfo={attributesExtraInfo}
      attributesUpperTitle={attributesUpperTitle}
      productName={productName}
      attributeTitlePrefix={attributeTitlePrefix}
    />
  </AnimationWrapper>
);

AnimatedVariantSelection.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  variants: PropTypes.arrayOf(PropTypes.object).isRequired,
  defaultSelectedSKU: PropTypes.string,
  onSelectVariant: PropTypes.func.isRequired,
  isShowingPriceDetails: PropTypes.bool,
  isShowingDiscountedPrices: PropTypes.bool,
  attributesExtraInfo: PropTypes.arrayOf(
    PropTypes.shape({
      attributeName: PropTypes.string.isRequired,
      isToolTip: PropTypes.bool.isRequired,
      text: PropTypes.string,
      content: PropTypes.string.isRequired,
    }),
  ),
  attributesUpperTitle: PropTypes.string,
  productName: PropTypes.string,
  attributeTitlePrefix: PropTypes.string,
  productKey: PropTypes.string,
};

export default AnimatedVariantSelection;
